import React from 'react'

import { SwiperSlide } from 'swiper/react'
import Card from '@/molecules/Card'
import BaseCarousel from '../BaseCarousel'

const CardCarousel = ({ items }) => {
  return (
    <BaseCarousel
      swiperProps={{
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 'auto',
          },
        },
      }}
    >
      {items.map(({ item, type }, i) => {
        return (
          <SwiperSlide
            key={i}
            style={{ width: '80%' }}
          >
            <Card
              key={i}
              data={item}
              type={type}
              renderedBy={'slider'}
            />
          </SwiperSlide>
        )
      })}
    </BaseCarousel>
  )
}

export default CardCarousel
